















































import { Component, Mixins } from 'vue-property-decorator'
import ButtonBase from '@/components/atoms/ButtonBase.vue'
import RadioImaged from '@/components/atoms/RadioImaged.vue'
import StudyRouting from '@/views/student/study/StudyRouting.vue'

@Component({
  components: {
    ButtonBase,
    RadioImaged,
  },
})
export default class StudyDrill extends Mixins(StudyRouting) {
  get contentSource(): string {
    return '/student/study/drill/drill-' + this.$route.params.id
  }
}
